<template>
  <div id="loading">
    <div class="modal-body">
      <div class="info text-center">
        <h4 :class="'text-uppercase ' + (info.spinner ? '--searching' : (info.success ? '--success' : '--warning'))">
          <i v-show="!info.spinner" class="fa fa-exclamation-triangle" aria-hidden="true"></i>
          {{info.title}}
        </h4>
        <h5 v-if="info.spinner">
          <i class="custom-loading-color fa fa-spinner fa-spin fa-4x fa-fw"></i>
        </h5>
        <h5 v-else>
          {{info.msg}}
        </h5>
        
        <button id="info-button" v-show="!info.spinner" :class="'btn btn-' + (info.success ? 'success' : 'danger')" data-dismiss="modal">Regresar</button>
      </div>
    </div>
    <button id="dismiss-button" data-dismiss="modal"></button>
  </div>
</template>

<script>
// let $ = require('jquery')
export default {
  data() {
    return {
      info: {}
    }
  },
  mounted() {
  },
  watch: {
    info() {
    }
  },
  methods: {
    setInfo(options) {
      this.info = options
    },
    close() {
      // $('#dismiss-button[data-dismiss]').click()
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~varmix';

#loading {
  position: relative;
  .loading__login {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .fa-spinner {
      color: $amarilloL;
    }
    h4 {
      color: $amarilloO;
      position: absolute;
      left: -30px;
    }
  }
  #dismiss-button {
    position: absolute;
    z-index: -999999;
    visibility: hidden;
  }
  .info {
    position: absolute;
    background-color: white;
    width: 100%;
    top: 50%;
    left: 50%;
    color: var(--btn-default-bg);
    transform: translate(-50%, -50%);
    h4 {
      margin: 0;
      padding: 50px;
      color: white;
      margin-top: -100px;
    }
    .fa-exclamation-triangle {
      color: white;
    }
    .--warning {
      background-color: $rojoMapa;
    }
    .--success {
      background-color: $verdeMapa;
    }
    .--searching {
      background-color: var(--btn-default-bg);
    }
    h5 {
      padding: 50px 0;
      color: black;
    }
    #info-button {
      margin-bottom: 25px;
    }
  }
}

.modal-body {
  height: 55vh;
  background-color: transparent;
  @include celphone {
    height: 38vh;
  }
}
</style>



// WEBPACK FOOTER //
// Loading.vue?3be3eb02